import { BiBox, BiEdit, BiPlusCircle, BiSearchAlt, BiTransfer } from 'react-icons/bi';

/** A consulta busca no servidor e a janela do resultado demora a abrir. */
const ESPERA_DO_RESULTADO_MS = 20000;

export const abrirOPatrimonio = {
  alvo: 'menu:Patrimônio',
  titulo: 'Abra o Patrimônio',
  texto: 'Clique em Patrimônio.',
  lado: 'right',
  exigeClique: true,
};

const buscarOEquipamento = {
  alvo: 'consulta:busca',
  titulo: 'Busque o equipamento',
  texto:
    'Digite o MAC, o número de série ou a etiqueta. Buscar assim, sem escolher cliente, responde na hora.',
  lado: 'bottom',
  avancaAoDigitar: true,
};

const clicarEmConsultar = {
  alvo: 'consulta:consultar',
  titulo: 'Consultar',
  texto: 'Clique em Consultar. O resultado abre numa janela.',
  lado: 'top',
  exigeClique: true,
};

export const cadastrarEquipamento = {
  id: 'cadastrar-equipamento',
  titulo: 'Cadastrar um equipamento avulso',
  descricao: 'Para o aparelho que chegou sem nota fiscal ou que ainda não tem etiqueta.',
  icone: BiPlusCircle,
  passos: [
    abrirOPatrimonio,
    {
      alvo: 'aba:Cadastro',
      titulo: 'Cadastro',
      texto: 'Clique na aba Cadastro.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'cadastro:identificacao',
      titulo: 'Identificação do equipamento',
      texto:
        'Cliente, anexo, fornecedor, marca e modelo. O anexo é obrigatório. Aparelho em estoque vai no cliente VOXCITY TECNOLOGIA.',
      fala: 'Cliente, anexo, fornecedor, marca e modelo. O anexo é obrigatório. Aparelho em estoque vai no cliente Vox City Tecnologia.',
      lado: 'bottom',
    },
    {
      alvo: 'cadastro:usuario',
      titulo: 'Detalhes do usuário',
      texto: 'Nome, setor, ramal, IP e senha. Preencha só se o aparelho já tem destino.',
      lado: 'bottom',
    },
    {
      alvo: 'cadastro:tecnica',
      titulo: 'Identificação técnica',
      texto: 'Número de série, MAC e número da etiqueta de patrimônio. Confira com o aparelho na mão.',
      lado: 'top',
    },
    {
      alvo: 'cadastro:salvar',
      titulo: 'Salvar',
      texto:
        'Salvar grava o cadastro. Salvar e Imprimir grava e já imprime a etiqueta para colar no aparelho.',
      lado: 'top',
    },
  ],
};

export const consultarPatrimonios = {
  id: 'consultar-patrimonios',
  titulo: 'Consultar patrimônios',
  descricao: 'Ache um equipamento pelo MAC, série ou etiqueta e exporte o resultado.',
  icone: BiSearchAlt,
  passos: [
    abrirOPatrimonio,
    {
      alvo: 'aba:CONSULTA NOVO',
      titulo: 'Consulta Novo ou Inventário',
      texto:
        'Consulta Novo procura nos patrimônios vindos de nota fiscal. Consulta Inventário procura na base antiga.',
      lado: 'bottom',
    },
    {
      alvo: 'consulta:id_cliente',
      titulo: 'Cliente e anexo',
      texto:
        'São opcionais e restringem a busca. Não escolha VOXCITY TECNOLOGIA sem preencher a Busca: são milhares de linhas e a tela pode travar por mais de um minuto.',
      fala: 'São opcionais e restringem a busca. Não escolha Vox City Tecnologia sem preencher a Busca: são milhares de linhas, e a tela pode travar por mais de um minuto.',
      lado: 'bottom',
    },
    {
      ...buscarOEquipamento,
      titulo: 'Busca',
      texto: 'Digite um MAC, número de série, etiqueta ou modelo (ex.: GRP2601).',
      fala: 'Digite um MAC, número de série, etiqueta ou modelo, como G R P vinte e seis zero um.',
    },
    clicarEmConsultar,
    {
      alvo: 'tabela:primeira-linha',
      titulo: 'Resultado',
      texto: 'Cada linha traz o número do patrimônio, o equipamento, MAC, série, cliente, anexo e ID.',
      lado: 'bottom',
      paciencia: ESPERA_DO_RESULTADO_MS,
    },
    {
      alvo: 'tabela:pesquisar',
      titulo: 'Filtrar o resultado',
      texto: 'Filtra as linhas já encontradas, sem consultar de novo.',
      lado: 'bottom',
    },
    {
      alvo: 'tabela:exportar',
      titulo: 'Gerar PDF e XLS',
      texto:
        'Exporta o resultado. O PDF de um lote serve de romaneio da caixa; o XLS é a lista que vai para o Staging.',
      lado: 'top',
    },
  ],
};

export const movimentarEquipamentos = {
  id: 'movimentar-equipamentos',
  titulo: 'Movimentar equipamentos',
  descricao:
    'Envio, retorno, defeito ou troca de anexo: tudo que sai ou volta é movimentado no mesmo dia.',
  icone: BiTransfer,
  passos: [
    abrirOPatrimonio,
    buscarOEquipamento,
    clicarEmConsultar,
    {
      alvo: 'tabela:marcar',
      titulo: 'Marque o patrimônio',
      texto:
        'Marque a caixinha de cada patrimônio do lote. O topo da janela mostra quantos estão selecionados.',
      lado: 'right',
      exigeClique: true,
      paciencia: ESPERA_DO_RESULTADO_MS,
    },
    {
      alvo: 'consulta:movimentar',
      titulo: 'Movimentar',
      texto: 'Clique em Movimentar. Nada é gravado ainda: abre a janela de destino.',
      lado: 'top',
      exigeClique: true,
    },
    {
      alvo: 'movimentar:cliente',
      titulo: 'Cliente de destino',
      texto:
        'Envio: o cliente do contrato. Retorno, defeito, separação para o Staging ou troca de unidade: VOXCITY TECNOLOGIA.',
      fala: 'Envio: o cliente do contrato. Retorno, defeito, separação para o Staging ou troca de unidade: Vox City Tecnologia.',
      lado: 'bottom',
    },
    {
      alvo: 'movimentar:anexo',
      titulo: 'Anexo de destino',
      texto:
        'Envio: o anexo do contrato ou do local. Retorno: SEDE VOX. Defeito: VOXCITY CRICIUMA (APARELHOS COM DEFEITO).',
      fala: 'Envio: o anexo do contrato ou do local. Retorno: Sede Vox. Defeito: Vox City Criciúma, aparelhos com defeito.',
      lado: 'bottom',
    },
    {
      alvo: 'movimentar:lista',
      titulo: 'Confira a lista',
      texto: 'Confira ID, modelo e etiqueta de cada patrimônio antes de confirmar.',
      lado: 'top',
    },
    {
      alvo: 'movimentar:confirmar',
      titulo: 'Confirmar Movimentação',
      texto:
        'Este botão grava a movimentação no Histórico, com o seu usuário e o horário. O tutorial não clica nele: confirme quando o lote for de verdade.',
      lado: 'top',
    },
  ],
};

export const editarERegistrarEnvio = {
  id: 'editar-e-registrar-envio',
  titulo: 'Editar e registrar o envio',
  descricao: 'Atualize nome, setor, ramal e IP e registre a data e a hora em que o aparelho saiu.',
  icone: BiEdit,
  passos: [
    abrirOPatrimonio,
    buscarOEquipamento,
    clicarEmConsultar,
    {
      alvo: 'tabela:acoes',
      titulo: 'Editar',
      texto: 'Clique no lápis do patrimônio para abrir a edição.',
      lado: 'left',
      exigeClique: true,
      paciencia: ESPERA_DO_RESULTADO_MS,
    },
    {
      alvo: 'editar:basico',
      titulo: 'Informações básicas',
      texto: 'Equipamento, cliente, anexo, fornecedor, marca e modelo. Corrija aqui um cadastro errado.',
      lado: 'bottom',
      paciencia: 10000,
    },
    {
      alvo: 'editar:usuario',
      titulo: 'Detalhes do usuário',
      texto:
        'Nome, setor, ramal e IP. Preencha com o que o Staging devolveu depois do provisionamento.',
      lado: 'bottom',
    },
    {
      alvo: 'editar:envio',
      titulo: 'Controle de Envio',
      texto: 'No dia da coleta, preencha a data e a hora de envio. É o registro de quando o aparelho saiu.',
      lado: 'top',
    },
    {
      alvo: 'editar:imprimir',
      titulo: 'Imprimir etiqueta',
      texto: 'Imprime a etiqueta do patrimônio com o local, o setor e o ramal.',
      lado: 'top',
    },
    {
      alvo: 'editar:salvar',
      titulo: 'Salvar',
      texto: 'Salvar grava as alterações. O tutorial não clica nele.',
      lado: 'top',
    },
  ],
};

export const verOEstoque = {
  id: 'ver-o-estoque',
  titulo: 'Ver e separar o estoque',
  descricao: 'Liste o que está disponível por modelo e gere a lista de separação para o Staging.',
  icone: BiBox,
  passos: [
    abrirOPatrimonio,
    {
      alvo: 'aba:Estoque',
      titulo: 'Estoque',
      texto: 'Clique na aba Estoque.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'estoque:filtros',
      titulo: 'Filtros Avançados',
      texto: 'Clique em Filtros Avançados.',
      lado: 'bottom',
      exigeClique: true,
      paciencia: 10000,
    },
    {
      alvo: 'estoque:painel-filtros',
      titulo: 'Cliente e modelo',
      texto:
        'Escolha um ou mais modelos, e o cliente se precisar. Para separar um pedido, filtre pelo modelo pedido.',
      lado: 'right',
    },
    {
      alvo: 'estoque:aplicar',
      titulo: 'Aplicar',
      texto: 'Aplicar fecha o painel com os filtros escolhidos.',
      lado: 'right',
      avancaAoClicar: true,
    },
    {
      alvo: 'tabela:primeira-linha',
      titulo: 'Itens disponíveis',
      texto: 'Etiqueta, série, MAC, nome, marca, modelo e cliente de cada item em estoque.',
      lado: 'bottom',
      paciencia: ESPERA_DO_RESULTADO_MS,
    },
    {
      alvo: 'tabela:exportar',
      titulo: 'Lista de separação',
      texto:
        'Gere o XLS, separe os aparelhos e confira etiqueta, série e MAC de cada um com a lista. Ela vai para o Staging junto com o lote.',
      lado: 'top',
    },
  ],
};
